export const LOCALSTORAGE_LANGUAGE_KEY = 'i18next-language';
export var Languages;
(function (Languages) {
    Languages["En"] = "en-GB";
    Languages["Ru"] = "ru-RU";
    Languages["CIMode"] = "cimode";
})(Languages || (Languages = {}));
